import { render, staticRenderFns } from "./ContentUs.vue?vue&type=template&id=4632fbc4&scoped=true&"
import script from "./ContentUs.vue?vue&type=script&lang=js&"
export * from "./ContentUs.vue?vue&type=script&lang=js&"
import style0 from "./ContentUs.vue?vue&type=style&index=0&id=4632fbc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4632fbc4",
  null
  
)

export default component.exports